module.exports = __webpack_public_path__ + "img/pair_market_disable.2762146.jpg";